const brands = [
    {
        id: 1,
        name: "Brand0",
        founder: "Founder0",
        description: "This is the description of the brand number zero",
        imgPath: "/assets/images/brand0.jpg",
        instagram: "https://www.instagram.com/",
        facebook: "https://www.facebook.com/",
        team: [
            {
                name: "Mateo Hernández",
                img: "/assets/members/image2.jpeg",
                role: "Director General",
            },
            {
                name: "Alan Hurtado",
                img: "/assets/members/image3.jpeg",
                role: "Presidente",
            },
            {
                name: "Alondra Damian",
                img: "/assets/members/image1.jpeg",
                role: "Vicepresidente",
            },
        ],
        favorite: false,
    },
    {
        id: 2,
        name: "Brand1",
        founder: "Founder1",
        description: "This is the description of the brand number one",
        imgPath: "/assets/images/brand1.jpg",
        instagram: "https://www.instagram.com/",
        facebook: "https://www.facebook.com/",
        team: [
            {
                name: "Ester De La Torre",
                img: "/assets/members/image4.jpeg",
                role: "Director General",
            },
            {
                name: "Oswaldo Romo",
                img: "/assets/members/image11.jpeg",
                role: "Presidente",
            },
            {
                name: "Andrea Esparza",
                img: "/assets/members/image5.jpeg",
                role: "Vicepresidente",
            },
        ],
        favorite: false,
    },
    {
        id: 3,
        name: "Brand2",
        founder: "Founder2",
        description: "This is the description of the brand number two",
        imgPath: "/assets/images/brand2.jpg",
        instagram: "https://www.instagram.com/",
        facebook: "https://www.facebook.com/",
        team: [
            {
                name: "Monse Venegas",
                img: "/assets/members/image6.jpeg",
                role: "Director General",
            },
            {
                name: "Julieta Ávila",
                img: "/assets/members/image7.jpeg",
                role: "Presidente",
            },
            {
                name: "Javier Torres",
                img: "/assets/members/image13.jpeg",
                role: "Vicepresidente",
            },
        ],
        favorite: false,
    },
    {
        id: 4,
        name: "Brand3",
        founder: "Founder3",
        description: "This is the description of the brand number three",
        imgPath: "/assets/images/brand3.jpg",
        instagram: "https://www.instagram.com/",
        facebook: "https://www.facebook.com/",
        team: [
            {
                name: "Daniel Montoya",
                img: "/assets/members/image14.jpeg",
                role: "Director General",
            },
            {
                name: "Karla Blanco",
                img: "/assets/members/image8.jpeg",
                role: "Presidente",
            },
            {
                name: "José García",
                img: "/assets/members/image16.jpeg",
                role: "Vicepresidente",
            },
        ],
        favorite: false,
    },
    {
        id: 5,
        name: "Brand4",
        founder: "Founder4",
        description: "This is the description of the brand number four",
        imgPath: "/assets/images/brand4.jpg",
        instagram: "https://www.instagram.com/",
        facebook: "https://www.facebook.com/",
        team: [
            {
                name: "Pedro Jimenez",
                img: "/assets/members/image17.jpeg",
                role: "Director General",
            },
            {
                name: "Alexa Gutierrez",
                img: "/assets/members/image9.jpeg",
                role: "Gerente",
            },
            {
                name: "Sergio Furch",
                img: "/assets/members/image18.jpeg",
                role: "Vicepresidente",
            },
        ],
        favorite: false,
    },
    {
        id: 6,
        name: "Brand5",
        founder: "Founder5",
        description: "This is the description of the brand number five",
        imgPath: "/assets/images/brand5.jpg",
        instagram: "https://www.instagram.com/",
        facebook: "https://www.facebook.com/",
        team: [
            {
                name: "Rodrigo Medina",
                img: "/assets/members/image12.jpeg",
                role: "Director General",
            },
            {
                name: "Fernanda Ballesteros",
                img: "/assets/members/image15.jpeg",
                role: "Presidente",
            },
            {
                name: "Erick Lozano",
                img: "/assets/members/image2.jpeg",
                role: "Vicepresidente",
            },
        ],
        favorite: false,
    },
];

export default brands;
